<script>
    import user from "../stores/user.js";
    import R, {LOADER} from "../lib/requests";
    import PageInfo from "../components/pages/PageInfo.svelte";

    let request = null;
    let error = null;
    let pointsTransferred = null;

    const load = () => {
        const onSuccess = result => {
            pointsTransferred = result.data.points;
        }

        const onFailure = err => {
            if (err.code === 'not_found') {
                error = "request not found!";
                return;
            }
            if (err.code === 'request_expired') {
                error = "this request has been expired!";
                return;
            }
            if (err.code === 'request_completed') {
                error = "this request has been completed!";
                return;
            }
            if (err.code === 'insufficient_points') {
                error = "The request could not be completed due to an insufficient number of points of the requester!";
                return;
            }

            error = "there was an error with your request!";
        };

        R.handle(R.actionRequest.confirm, request, onSuccess, onFailure, LOADER.PAGE);
    }


    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('request')) {
        request = searchParams.get('request');
    }

    load();
</script>

<div class="page-overlay">
    <div class="page-wrapper">
        <div class="panel-simple panel-pad accept-points box-shadow rounded">
            <div class="form-logo mb-4">
                <img src="/assets/images/logo-rect-green.png" alt="logo">
            </div>
            <h2 class="fw-bold line-height-1">Accept Points</h2>

            {#if pointsTransferred}
                <PageInfo type="success" icon="check"
                          message="{ pointsTransferred } points have been transferred to your account!" internal/>
                <div class="text-center">
                    <a href="/" class="btn btn-primary rounded px-5">OK</a>
                </div>
            {/if}
            {#if error}
                <PageInfo message="{ error }" internal/>
                <div class="text-center">
                    <a href="/" class="btn btn-danger rounded px-4">Go back</a>
                </div>
            {/if}
        </div>
    </div>
</div>

<style>
    .page-wrapper {
        width: 95%;
        max-width: 400px;
        height: 100%;
        margin: auto;
        position: relative;
    }

    .accept-points {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
</style>